import { InitialLoadChangeLog } from "components/ChangeLog/ChangeLog";
import { Tutorials } from "components/Tutorial/Tutorials";
import React from "react";
import { InitialLoadConsentModal } from "./AnalyticsConsentModal";
import { PopupManagerProvider } from "./PopupManagerContext";

export const PopupManager = () => {
  return (
    <>
      <PopupManagerProvider>
        <Tutorials />
        <InitialLoadChangeLog />
        <InitialLoadConsentModal />
      </PopupManagerProvider>
    </>
  );
};
